"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.number.constructor");

var _BarChart = _interopRequireDefault(require("../components/v2charts/BarChart"));

var _CardInfoV = _interopRequireDefault(require("@/views/dashboard/components/CardInfo/Merchant/CardInfoV3"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "merchant-v3",
  components: {
    CardInfo: _CardInfoV.default,
    BarChart: _BarChart.default
  },
  props: {
    data: Object,
    loading: Boolean,
    labels: Array,
    values: Array,
    httpAPI: Object,
    smppAPI: Object,
    redirectToDocs: Function,
    approvalStatus: Object,
    orgStatus: Object,
    numberOfDecimal: Number
  },
  computed: {
    cardInfo: function cardInfo() {
      if (Object.keys(this.data).length === 0) return;
      return [[{
        icon: 'fas fa-wallet',
        label: this.$t('dashboard.merchant.availableBalance'),
        value: parseFloat(this.data.processAvailableAmount),
        decimal: true,
        // unit: this.$t('dashboard.moneyUnit'),
        numberOfDecimal: this.data.numberOfDecimal,
        color: 'Tan'
      }, {
        icon: 'fas fa-coins',
        label: this.$t('dashboard.merchant.frozenAmount'),
        value: parseFloat(this.data.processFrozenAmount),
        decimal: true,
        // unit: this.$t('dashboard.moneyUnit'),
        numberOfDecimal: this.data.numberOfDecimal,
        color: 'darksalmon'
      }], [{
        icon: 'fas fa-envelope',
        label: this.$t('dashboard.merchant.uncreditedAmount'),
        value: parseFloat(this.data.processUncreditedAmount),
        decimal: false,
        // unit: this.$t('dashboard.merchant.smsUnit'),
        numberOfDecimal: this.data.numberOfDecimal,
        color: 'SkyBlue'
      }, {
        icon: 'fas fa-receipt',
        label: this.$t('dashboard.merchant.totalRecharge'),
        value: parseFloat(this.data.processAmount),
        decimal: true,
        numberOfDecimal: this.data.numberOfDecimal,
        // unit: this.$t('dashboard.moneyUnit'),
        color: 'MediumAquaMarine'
      }]];
    }
  }
};
exports.default = _default;